import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import { Dispatch } from 'redux';
import { Button } from '@material-ui/core';

import * as types from '../../../actions/actionTypes';

export interface Props {
  dispatch: any;
  router: any;
  top: boolean;
}

export const BlurOverlay = (props: Props) => (
  <div
    className={`col-xs-12 row ${
      props.top ? 'top-xs' : 'middle-xs'
    } center-xs content-overlay`}
  >
    <div className="content-overlay-blur" />
    <div className="content-overlay-cta">
      <h2 className="override">Sign up for free to see this content</h2>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          props.dispatch({
            type: types.OpenSignupDialog,
          });
        }}
      >
        SIGN UP
      </Button>
    </div>
  </div>
);

export default connect()(withRouter(BlurOverlay));
